import { goalItems } from '../../constants/questioner';
import SelectImageButtons from '../SelectImageButtons/SelectImageButtons';
import ProgressBar from '../ProgressBar/ProgressBar';

import styles from './Steps.module.css';

const Step10 = (props) => {
  const { onSave, stepsData } = props;

  const onSaveHandler = (goal) => {
    onSave({ goal });
  };

  return (
      <div className={styles.stepWrapper}>
      <ProgressBar />
      <div className={styles.physicalActivity}>
        <div className={styles.stepHeader}>
          What is your goal?
        </div>
        <div className={styles.selectButtonsWrapper}>
          <SelectImageButtons
            buttonsData={goalItems}  
            onChange={onSaveHandler}
            defaultValue={stepsData.goal}
          />
        </div>
      </div>
      
    </div>
  );
};

export default Step10;